/**
 * Optional: Block bond details page during 4hr cooldown.
 * Add to page: definePageMeta({ middleware: 'bond-signup-gate' })
 * Or rename to bond-signup-gate.global.js for app-wide.
 */
const STORAGE_KEYS = {
  FORCED: 'bsg_forced',
  COOLDOWN_START: 'bsg_cooldown_start',
}
const COOLDOWN_MS = 4 * 60 * 60 * 1000

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return
  if (typeof globalThis.window === 'undefined') return
  if (!to.path.startsWith('/products/bonds/') || to.path === '/products/bonds') return

  const forced = localStorage.getItem(STORAGE_KEYS.FORCED)
  const start = localStorage.getItem(STORAGE_KEYS.COOLDOWN_START)
  if (forced !== 'true' || !start) return

  const elapsed = Date.now() - Number.parseInt(start, 10)
  if (elapsed >= COOLDOWN_MS) return

  return navigateTo('/products/bonds')
})
